import React from 'react';
import styles from './SocialLink.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

const SocialLink = ({
  link,
  icon,
}) => {
  return (
    <a
      href={link}
      target='_blank'
      rel='noopener noreferrer'
      className={cx('social-icon')}
    >
      {icon}
    </a>
  );
};

export default SocialLink;



// WEBPACK FOOTER //
// ./src/app/components/atoms/SocialLink/SocialLink.js